module.exports = __webpack_public_path__ + "img/2017_hayatomo.1afe48ce.jpg";